import { notifyInactive } from '../utils/inactiveBus';

export default async function fetchJson(url, options = {}) {
  try {
    const token = localStorage.getItem('token');
    const headers = {
      'Content-Type': 'application/json',
      ...(token ? { 'Authorization': `Bearer ${token}` } : {})
    };
    const response = await fetch(url, {
      ...options,
      headers: {
        ...headers,
        ...(options.headers || {})
      }
    });
    const status = response.status;
    const data = await response.json().catch(() => ({}));
    if (!response.ok) {
      const msg = data.message || data.error || `HTTP error! status: ${status}`;
      if (status === 403 && String(msg).toLowerCase().includes('inactive')) {
        // Broadcast inactive so UI can immediately switch without reload
        try { notifyInactive({ reason: 'inactive' }); } catch {}
      }
      return { data: null, error: msg, status };
    }
    return { data, error: null, status };
  } catch (err) {
    return { data: null, error: err.message, status: 0 };
  }
}